import React, { FC, useEffect, useState } from 'react'
import { SparklesIcon, LinkIcon } from '@heroicons/react/outline'
import { parse } from 'query-string'
import { useLocation, useHistory } from 'react-router-dom'
import payPalLogo from './paypal.png'
import { ReactComponent as Logo } from './logo.svg'
import { Button, Dialog } from '../../System'
import ROUTES from '../../utils/routes'
import { StyledPayPalConnectModal, useConnectPayPal } from '.'

type Props = {
  isOpen: boolean;
}

const PayPalConnectModal: FC<Props> = ({ isOpen }) => {
  const { actions: { connectPayPal } } = useConnectPayPal()
  const { search } = useLocation()
  const [loading, setLoading] = useState(false)
  const history = useHistory()
  const params = parse(search, { parseBooleans: true })

  useEffect(() => {
    if (params.code) {
      setLoading(true)
      connectPayPal(`${params.code}`)
      return
    }
    if (params.error) {
      setLoading(false)
    }
  }, [])

  return (
    <Dialog isOpen={isOpen} onClose={() => history.goBack()}>
      <StyledPayPalConnectModal>
        <div className="spacer">
          <div className="icon">
            <SparklesIcon />
          </div>
          <div className="details">
            <span className="title">
              Social Curator
              <br />
              Affiliate Program
            </span>
            <span className="description">
              It's easy to earn as a Social Curator Affiliate! Get started by connecting your PayPal
              account for automatic payouts!
            </span>
            <a href={ROUTES.external.affiliateProgramUrl} target="_blank" rel="noopener noreferrer">
              Read more about how our affiliate program works
            </a>
          </div>
        </div>
        <div className="link-figure">
          <Logo />
          <LinkIcon className="link-icon" />
          <img src={payPalLogo} alt="" />
        </div>
        <a href={ROUTES.external.payPalConnect}>
          <Button type="small" isLoading={loading}>
            Connect PayPal Account
          </Button>
        </a>
      </StyledPayPalConnectModal>
    </Dialog>
  )
}

export default PayPalConnectModal
